import React from "react";
import { FilterListRenderContextType } from "./context";
import {
  FilterRenderContextType,
  GenericFilterListScreenOptions,
  SetScreenOptionsFn,
} from "./types";

export const useGenericFilterListScreen = (): FilterRenderContextType => {
  const [screenOptions, setScreenOptions] = React.useState<
    GenericFilterListScreenOptions | undefined
  >(undefined);

  const setScreenOptionsFn: SetScreenOptionsFn = React.useCallback(
    (options) => {
      setScreenOptions(options);
    },
    []
  );

  const clearScreenOptions = React.useCallback(() => {
    setScreenOptions(undefined);
  }, []);

  return {
    screenOptions,
    setScreenOptions: setScreenOptionsFn,
    clearScreenOptions,
  };
};

export const useGenericFilterListScreenProvider = () => {
  const context = React.useContext(FilterListRenderContextType);

  if (!context) {
    throw new Error("FilterListRenderContextType is not provided");
  }

  return context;
};
